import Redirect from 'route/components/Redirect';
import routeConstant, { refactorRoute } from 'route/routeConstant';
import LoaderBuilder from './components/LoaderBuilder';
import congTacXaHoiRoutes from './CongTacXaHoiRoutes';
import donorDetailRoutes from './DonorRoutes';
import homeRoutes from './HomeRoutes';
import patientDetailRoutes from './PatientRoutes';
import postTransplantRoutes from './PostTransplantRoutes';

const routes = [
    {
        name: 'Home',
        path: refactorRoute.AUTH,
        component: LoaderBuilder(() => import('view/Authenticate')),
        children: [
            {
                name: 'Home - Default',
                path: refactorRoute.AUTH,
                component: () => <Redirect to={refactorRoute.LOGIN} />,
            },
            {
                name: 'Login',
                path: refactorRoute.LOGIN,
                component: LoaderBuilder(
                    () => import('view/Authenticate/Login')
                ),
            },
        ],
    },
    {
        name: 'Donor Detail',
        path: refactorRoute.DONOR_DETAIL,
        component: LoaderBuilder(() => import('view/DonorDetail')),
        children: donorDetailRoutes,
    },
    {
        name: 'Patient Detail',
        path: refactorRoute.PATIENT_DETAIL,
        component: LoaderBuilder(() => import('view/PatientDetail')),
        children: patientDetailRoutes,
    },
    {
        name: 'Social Work Detail',
        path: refactorRoute.CONG_TAC_XA_HOI_DETAIL,
        component: LoaderBuilder(() => import('view/CongTacXaHoiChiTiet')),
        children: congTacXaHoiRoutes,
    },
    ...homeRoutes,
    ...postTransplantRoutes,
    {
        name: 'Donor View PDF',
        path: routeConstant.ROUTE_DONOR__VIEW_PDF,
        component: LoaderBuilder(() => import('view/DonorLayout/ExportPDF')),
    },
    {
        name: 'Recipient View PDF',
        path: refactorRoute.PATIENT_DETAIL_PDF,
        component: LoaderBuilder(
            () => import('view/RecipientLayout/ExportPDF')
        ),
    },
    {
        name: 'Default',
        path: '*',
        component: () => <Redirect to={refactorRoute.LOGIN} />,
    },
];

export default routes;
